module.exports = __webpack_public_path__ + "img/ShortsDislike.7bdcbeaa.svg";